// extracted by mini-css-extract-plugin
export default {"nutritionFactsModal":"r584_P","turkey":"AglaP3","chicken":"hkLRvo","pork":"isUwy9"};